export default {
  momentLocale: 'id',
  Timeline: {
    expand: 'Membuka',
    fold: 'Sembunyikan',
  },
  Balloon: {
    close: 'Tutup',
    confirm: 'Ya',
    cancel: 'Batal',
  },
  Card: {
    expand: 'Membuka',
    fold: 'Sembunyikan',
  },
  Calendar: {
    today: 'Hari ini',
    now: 'Saat ini',
    ok: 'Konfirmasi',
    clear: 'Hapus',
    month: 'Bulan',
    year: 'tahun',
    prevYear: 'Tahun lalu',
    nextYear: 'tahun depan',
    prevMonth: 'Bulan Lalu',
    nextMonth: 'Bulan depan',
    prevDecade: 'Tahun Sebelumnya 12',
    nextDecade: '12 tahun kemudian',
    yearSelectAriaLabel: 'Pilih Tahun',
    monthSelectAriaLabel: 'Pilih Bulan',
    format: {
      months: '1 Bulan_2 Bulan_3 Bulan_4 Bulan_5 Bulan_6 Bulan_7 Bulan_8 Bulan_9 Bulan_10 Bulan_11 Bulan_12 Bulan'.split(
        '_',
      ),
      shortMonths: '1 Bulan_2 Bulan_3 Bulan_4 Bulan_5 Bulan_6 Bulan_7 Bulan_8 Bulan_9 Bulan_10 Bulan_11 Bulan_12 Bulan'.split(
        '_',
      ),
      weekdays: 'Minggu_Senin_Selasa_Rabu_Kamis_Jumat_Sabtu'.split('_'),
      shortWeekdays: 'Ming_Sen_Sel_Rab_Kam_Jum_Sab'.split('_'),
      veryShortWeekdays: 'Ming_Sen_Sel_Rab_Kam_Jum_Sab'.split('_'),
      yearLabel: 'Tahun YYYY',
    },
  },
  DatePicker: {
    placeholder: 'Silakan pilih tanggal',
    datetimePlaceholder: 'Silakan pilih tanggal dan waktu',
    monthPlaceholder: 'Silakan pilih bulan',
    yearPlaceholder: 'Silakan pilih tahun',
    now: 'Saat ini',
    selectTime: 'Pilih Waktu',
    selectDate: 'Pilih tanggal',
    ok: 'Konfirmasi',
    clear: 'Hapus',
    startPlaceholder: 'Tanggal mulai',
    endPlaceholder: 'Tanggal Akhir',
    hour: 'Waktu',
    minute: 'menit',
    second: 'detik',
  },
  Dialog: {
    close: 'Tutup',
    ok: 'Konfirmasi',
    cancel: 'Batal',
  },
  Message: {
    closeAriaLabel: 'Tutup',
  },
  Pagination: {
    goTo: 'Ke',
    page: 'Halaman',
    total: 'Halaman {current} dari {total}',
    labelPrev: 'Halaman sebelumnya, halaman saat ini {current}',
    labelNext: 'Halaman berikutnya, halaman saat ini {current}',
    inputAriaLabel: 'Silakan masukkan nomor halaman yang ingin Anda tuju',
    selectAriaLabel: 'Silakan pilih berapa banyak entri yang akan ditampilkan per halaman',
    pageSize: 'Baris/Halaman',
  },
  Input: {
    clear: 'Hapus',
  },
  Select: {
    selectPlaceholder: 'Silakan pilih',
    autoCompletePlaceholder: 'Silakan masukkan',
    notFoundContent: 'Tidak ada pilihan',
    maxTagPlaceholder: '{selected}/{total} item terpilih',
  },
  Table: {
    empty: 'Tidak ada data',
    ok: 'Konfirmasi',
    reset: 'Mereset',
    asc: 'Urutan Naik',
    desc: 'Urutan menurun',
    expanded: 'Sudah Dibuka',
    folded: 'Ditumpuk',
    filter: 'Saring',
    selectAll: 'Pilih Semua',
  },
  TimePicker: {
    placeholder: 'Silakan pilih waktu',
    startPlaceholder: 'Waktu Mulai',
    endPlaceholder: 'Waktu akhir',
    clear: 'Hapus',
    hour: 'waktu',
    minute: 'mnt',
    second: 'detik',
  },
  Transfer: {
    items: 'item',
    item: 'item',
    moveAll: 'Pindah Semua',
    searchPlaceholder: 'Silakan masukkan',
    moveToLeft: 'Batalkan pilihan elemen',
    moveToRight: 'Kirim elemen yang dipilih',
  },
  Upload: {
    card: {
      cancel: 'Batal',
      addPhoto: 'Unggah gambar',
      download: 'Unduh',
      delete: 'Hapus',
    },
    drag: {
      text: 'Klik atau seret file ke kotak berbentuk garis-garis untuk mengunggah',
      hint: 'Mendukung jenis file seperti docx, xls, PDF, rar, zip, PNG, JPG, dan lainnya.',
    },
    upload: {
      delete: 'Hapus',
    },
  },
  Search: {
    buttonText: 'Cari',
  },
  Tag: {
    delete: 'Hapus',
  },
  Rating: {
    description: 'Opsi Penilaian',
  },
};
